module.exports = __webpack_public_path__ + "static/about_system_visibility-be1d23f9b0bd963770578002cdec9c76.png";